export default {
  init() {
    // google maps script is added in setup.php
    const google = window.google;

    // map container
    const mapDiv = document.getElementById('map');
    // use data attributes to pass custom settings
    const address = mapDiv.getAttribute('data-map-address');

    /** Normal google maps stuff below */
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode(
      {
        address,
      },
      (res, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          const map = new google.maps.Map(mapDiv, {
            center: res[0].geometry.location,
            zoom: 15,
          });

          const marker = new google.maps.Marker({
            map,
            position: res[0].geometry.location,
          });

          // use Tailwind classes to style the info window
          const infoWindowContent = `<h4 class="text-18 font-bold">${mapDiv.getAttribute(
            'data-company-name'
          )}</h4><p class="text-16">${address}</p><a class="text-16 font-bold" href="https://www.google.com/maps/dir//${
            res[0].formatted_address
          }" target="_blank" rel="noopener noreferrer">Directions</a>`;

          const infoWindow = new google.maps.InfoWindow({
            content: infoWindowContent,
          });

          infoWindow.open(map, marker);

          return [map, marker];
        }
      }
    );
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contactUs.js